import { Phone, Clock, Send, Brain } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const AiInsights = () => {
    return (
        <div className="p-6 space-y-6">
            <div>
                <h1 className="text-3xl font-bold" style={{ color: '#2C5F7F' }}>AI Insights</h1>
                <p className="text-gray-600 mt-1">Intelligent analytics and predictive patterns for your child's wellbeing</p>
            </div>

            {/* Coming Soon Card */}
            <Card className="border-2 border-dashed border-gray-300">
                <CardContent className="p-12 text-center">
                    <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Brain className="w-10 h-10 text-blue-600" />
                    </div>

                    <h2 className="text-2xl font-bold mb-3" style={{ color: '#2C5F7F' }}>
                        Coming Soon
                    </h2>

                    <p className="text-gray-600 mb-6 max-w-md mx-auto">
                        Our AI-powered insights system analyzes communication patterns, mood indicators,
                        and engagement levels to provide you with meaningful data about your child's emotional
                        wellbeing and social development.
                    </p>

                   

                    <p className="text-sm text-gray-500 mt-6">
                        Stay tuned for updates!
                    </p>
                </CardContent>
            </Card>
        </div>
    );
};

export default AiInsights;
